module.exports = __webpack_public_path__ + "img/alloys.c46622e.webp";